import get from 'lodash/get';
import { ArrayNotEmpty, IsNotEmpty, IsString, ValidateNested, Matches, Validate } from 'class-validator';
import { Type } from 'class-transformer';

import BaseIvrNode, { EMPTY_NEXT_ID_MESSAGE } from './baseIvrNode';
import { TIME_PATTERN } from 'src/models/BusinessHours/OfficeHours';
import { TimeRangesAreValid } from 'src/actions/endpoints/timeRangeValidator';
import { IsStartBeforeEndDateTime } from 'src/models/Ivrs/Nodes/validation/IsStartBeforeStopDateTime';

export enum ScheduleType {
  SCHEDULE_TYPE_DATE = 'SCHEDULE_TYPE_DATE',
  SCHEDULE_TYPE_WEEKDAY = 'SCHEDULE_TYPE_WEEKDAY',
}

export default class ScheduleNode extends BaseIvrNode {
  @ValidateNested({ each: true })
  @Type(() => NodeScheduleItem)
  nodeSchedules: NodeScheduleItem;

  @IsString()
  @IsNotEmpty({ message: 'Please select the default next node the customer will go to' })
  defaultNextId: string;
}

export class NodeScheduleItem {
  @ValidateNested({ each: true })
  @Type(() => ScheduleSchedule)
  schedule: ScheduleSchedule;

  @IsString()
  @IsNotEmpty({ message: EMPTY_NEXT_ID_MESSAGE })
  nodeId: string;
}

class ScheduleSchedule {
  @IsString()
  @IsNotEmpty()
  type: ScheduleType;

  @ValidateNested()
  @Type((typeHelper: any) =>
    get(typeHelper, 'object.type') === ScheduleType.SCHEDULE_TYPE_DATE ? NodeScheduleDate : NodeScheduleDaysOfWeek
  )
  schedule: NodeScheduleDate | NodeScheduleDaysOfWeek;
}

class NodeSchedule {
  @IsString()
  location: string;
}

export class ScheduleBlock {
  @Matches(TIME_PATTERN, { message: 'Invalid time format' })
  @IsNotEmpty({ message: 'Start time needs to be filled' })
  @IsStartBeforeEndDateTime()
  start: string;

  @Matches(TIME_PATTERN, { message: 'Invalid time format' })
  @Validate(TimeRangesAreValid)
  @IsNotEmpty({ message: 'End time needs to be filled' })
  end: string;
}

class NodeScheduleDate extends NodeSchedule {
  @IsString()
  @IsNotEmpty()
  date: string;

  @ValidateNested({ each: true })
  @Type(() => ScheduleBlock)
  timeRanges: ScheduleBlock[];
}

class NodeScheduleDaysOfWeek extends NodeSchedule {
  @ArrayNotEmpty({
    message: 'Days of week should not be empty',
  })
  daysOfTheWeek: string[];

  @ValidateNested({ each: true })
  @Type(() => ScheduleBlock)
  TimeRanges: ScheduleBlock[];
}
